<template>
  <div id="page">
    <router-view />
    <PcVideoCallDialog />
    <dailyAttendance></dailyAttendance>
  </div>
</template>

<script>
import dailyAttendance from './components/popup/dailyAttendance.vue';
import PcVideoCallDialog from '@/views/goEasy/components/pc-video-call-dialog.vue';
export default {
  name: 'App',
  components:{
    dailyAttendance,
    PcVideoCallDialog,
  },
  data() {
    return {
      gradeList: [], // 年级
      stageList: [], // 学段
      subjectList: [], // 学科
      termList: [], // 学期
      publisherList: [], // 版本
      textBookList: [], // 教材
      difficultyList: [], // 课程难易程度
    }
  },
  created() {
    this.getGrade();
    this.getSubject();
    this.getTerm();
    this.getPublisher();
    this.getTextbook();
    this.getDifficulty();
    this.getCourseType();
  },
  methods: {
    // 获取学段
    getGrade() {
      this.$Api.common.getGrade().then(res => {
        if (!res.data.data) return
        res.data.data.forEach((item) => {
          this.gradeList.push({ gradeId: item.gradeId, gradeName: item.gradeName, stageId: item.stageId, stageName: item.stageName });
          this.stageList.push({ stageId: item.stageId, stageName: item.stageName });
        })
        this.stageList = this.$Tools.uniqueByMap(this.stageList, 'stageId');
        // 存缓存
        this.$store.commit('filter/setStageList', this.stageList);
        this.$store.commit('filter/setGradeList', this.gradeList);
      }).catch(() => {})
    },
    // 获取学科
    getSubject() {
      this.$Api.common.getSubject().then(res => {
        if (!res.data.data) return
        this.subjectList = res.data.data;
        // 存缓存
        this.$store.commit('filter/setSubjectList', this.subjectList);
      }).catch(() => {})
    },
    // 获取学期
    getTerm() {
      this.$Api.common.getTerm().then(res => {
        if (!res.data.data) return
        this.termList = res.data.data;
        // 存缓存
        this.$store.commit('filter/setTermList', this.termList);
      }).catch(() => {})
    },
    // 获取版本
    getPublisher() {
      this.$Api.common.getPublisher().then(res => {
        if (!res.data.data) return
        this.publisherList = res.data.data;
        // 存缓存
        this.$store.commit('filter/setPublisherList', this.publisherList);
      }).catch(() => {})
    },
    // 获取教材
    getTextbook() {
      this.$Api.common.getTextbook().then(res => {
        if (!res.data.data) return
        this.textBookList = res.data.data;
        // 存缓存
        this.$store.commit('filter/setTextBookList', this.textBookList);
      }).catch(() => {})
    },
    // 获取课程难易程度
    getDifficulty() {
      this.$Api.common.getDifficulty().then(res => {
        if (!res.data.data) return
        // this.difficultyList = res.data.data;
        for (let key in res.data.data) {
          this.difficultyList.push({ difficultyId: key, difficultyName: res.data.data[key] })
        }
        // 存缓存
        this.$store.commit('filter/setDifficultyList', this.difficultyList);
      }).catch(() => {})
    },
    // 获取课程类型列表
    getCourseType(){
      this.$Api.common.getCourseType({status:1}).then(res => {
        if (!res.data.data) return
        let courseTypeList = res.data.data.map(item=>{
          return {
            value:item.typeId?Number(item.typeId):item.typeId,
            label:item.typeName
          }
        })
        // 存缓存
        this.$store.commit('filter/setCourseTypeList', courseTypeList);
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss">
body {
  margin: 0;
  padding: 0;
  min-width: 1920px;
}
@media (min-width: 1920px) {
  body {
    // width: 1920px;
    overflow-x: auto;
  }
}

#app {
  // width: 100vw;
  font-size: $fontBg;
  color: $color;
}
</style>
